import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { User } from '../models/user.model';
import { ModelFactory } from './model-factory.service';
import { Role } from '../models/role.model';
import { Customer } from '../models/customer.model';
import { Relationships } from '../models/relationships';

@Injectable()
export class UserFactory extends ModelFactory<User> {
  protected resourceName: string = 'user';
  protected resourceNamePlural: string = 'users';
  protected Model: { new(m: any): User } = User;
  protected extractResourceStrategy: (body: any) => {} = this.platformControllerExtractResourceStrategy;
  protected buildResourceStrategy: (model: User) => {} = this.platformControllerBuildUserResourceStrategy;
  protected relationships: Relationships = {
    roles: {
      Model: Role,
      toMany: true,
    },
    customers: {
      Model: Customer,
      toMany: true,
    },
    createdBy: {
      Model: User,
      toMany: false,
    },
  };

  private platformControllerBuildUserResourceStrategy(user: User) {
    return {
      name: user.name,
      email: user.email,
      password: user.password || undefined,
      roleIds: _.map(user.roles, 'id'),
      customerIds: _.map(user.customers, 'id'),
      daily_notifications: user.dailyNotifications,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/factories/user.factory.ts